import { IWbAppInfo } from '@interco/inter-webview-bridge'

type TBaseComponent<T> = {
  isActive: boolean
  content: T
}

type TGenericFeatureCard = {
  isActive: boolean
  title: string
  details: string
  confirmButton: string
  to: string
}

type TBabi = {
  isActive: boolean
}

type THelpCenterButton = {
  isActive: boolean
  icon: string
  buttonText: string
}

type TGenericFeedback = {
  icon?: string
  iconColor?: string
  title: string
  details: string
  confirmButton: string
  cancelButton?: string
  email?: string
}

type TMenuButton = {
  isActive: boolean
  route: string
  icon: string
  title: string
  details: string
}

const Entities = ['BR', 'US_BRANCH'] as const

const entityMap: Record<string, TEntity> = {
  BR: 'BR',
  US_BRANCH: 'US_BRANCH',
  US: 'BR',
  AR: 'BR',
}

const entityPayloadMap: Record<TEntity, string> = {
  BR: 'BR',
  US_BRANCH: 'US_BRANCH',
}

type TEntity = typeof Entities[number]

type TUserType = IWbAppInfo['organization']

type TCountry = Exclude<IWbAppInfo['organization'], 'MEI' | 'PF' | 'PJ'> | 'BR'

type TLanguage = IWbAppInfo['language']

type TTermType = 'privacyPolicyBR' | 'privacyPolicyUS' | 'privacyNoticeUS'

export type {
  TBaseComponent,
  TGenericFeatureCard,
  TBabi,
  THelpCenterButton,
  TGenericFeedback,
  TMenuButton,
  TEntity,
  TUserType,
  TCountry,
  TLanguage,
  TTermType,
}

export { Entities, entityMap, entityPayloadMap }
